module.exports = __webpack_public_path__ + "img/volvo.1ac51a75.png";